<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">认证记录列表</div>
    <div style="padding: 20px">
      <div class="container">
        <div>
          <div style="text-align: left; margin-bottom: 10px">
            <span>医生姓名</span>
            <el-input
              v-model="doctorName"
              style="width: 160px; margin: 0 20px 0 10px"
              @input="search"
              clearable
            ></el-input>
            <span>手机号</span>
            <el-input
              v-model="doctorPhone"
              style="width: 160px; margin: 0 10px"
              @input="search"
              clearable
            ></el-input>
            <span>所在省市</span>
            <el-select
              v-model="province_id"
              placeholder="请选择"
              @change="search"
              style="width: 140px; margin: 0 10px"
              clearable
            >
              <el-option
                v-for="item in proList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
            <span style="color: #707070; margin: 0 10px 0 30px">提交时间</span>
            <span class="mydate">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 260px"
                @change="search"
              ></el-date-picker>
            </span>
            <el-button
              plain
              style="font-weight: 700; margin-left: 10px; background: #ececec"
              @click="search"
              >查询</el-button
            >
          </div>
          <div class="searchbox">
            <span>
              <span style="margin-right: 10px">审核状态</span>
              <el-radio-group v-model="authStatus" @change="changeLogList">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="2">审核中</el-radio>
                <el-radio :label="3">审核通过</el-radio>
                <el-radio :label="4">审核不通过</el-radio>
              </el-radio-group>
            </span>
            <el-button
              type="primary"
              @click="examineAll"
              style="width: 120px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('30') : false
              "
              >批量审核</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @selection-change="handleSelectionChangetable"
          >
            <el-table-column type="selection"></el-table-column>

            <el-table-column
              label="提交时间"
              prop="update_time"
            ></el-table-column>
            <el-table-column label="医生头像" prop="name">
              <template slot-scope="scope">
                <img
                  :src="scope.row.head_img"
                  alt
                  style="width: 40px; height: 40px"
                />
              </template>
            </el-table-column>
            <el-table-column prop="doctor_name" label="医生信息">
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor: pointer"
                    >{{ scope.row.doctor_name }}</span
                  >
                  <span v-if="scope.row.sex == 1" style="margin-left: 16px"
                    >男</span
                  >
                  <span v-if="scope.row.sex == 2" style="margin-left: 16px"
                    >女</span
                  >
                </div>
                <div>
                  <span>{{ scope.row.phone }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="province_name"
              label="所在省市"
            ></el-table-column>

            <el-table-column prop="hospital" label="医院名称"></el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>

            <el-table-column label="审核状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 2" style="color: #669961"
                  >审核中</span
                >
                <span v-if="scope.row.status == 3">审核通过</span>
                <span v-if="scope.row.status == 4" style="color: #d0523c"
                  >审核不通过</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.reviewed_id)"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('31') : false
                  "
                  >审核详情</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.status == 2"
                  @click="examine(scope.row)"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('30') : false
                  "
                  >审核</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="审核"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="reasonShow"
      width="900px"
      class="other"
    >
      <div style="text-align: left; padding: 20px 20px 0">
        <div class="other-item">
          <div
            class="title"
            style="width: 100px; text-align: right; padding-right: 20px"
          >
            审核意见
          </div>
          <el-radio-group v-model="auth_status" style="padding-top: 2px">
            <el-radio :label="3">通过</el-radio>
            <el-radio :label="4">不通过</el-radio>
          </el-radio-group>
        </div>

        <!-- 开方权限 -->
        <div v-if="auth_status == 3" class="other-item">
          <div
            class="title"
            style="width: 100px; text-align: right; padding-right: 20px"
          >
            开方权限
          </div>
          <el-radio-group v-model="is_pre" style="padding-top: 2px">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="auth_status == 3"
          style="padding-left: 120px; margin-bottom: 10px; color: #f56c6c"
        >
          注：仅3年以上工作经验可开启开方权限
        </div>

        <div
          v-if="auth_status == 3 && !is_major_name"
          class="other-item"
          style="align-items: center"
        >
          <div
            class="title"
            style="width: 100px; text-align: right; padding-right: 20px"
          >
            医生所在专业
          </div>
          <el-input
            v-model="major_name"
            placeholder="请输入"
            style="width: 400px"
            size="small"
            maxlength="10"
          ></el-input>
        </div>

        <div v-if="auth_status == 4" class="other-item">
          <div class="title" style="width: 170px">不通过原因</div>
          <el-checkbox-group v-model="refuseList" size="small">
            <el-checkbox label="头像不合规">头像不合规</el-checkbox>
            <el-checkbox label="姓名不一致">姓名不一致</el-checkbox>
            <el-checkbox label="上传证书不合规">上传证书不合规</el-checkbox>
            <el-checkbox label="身份证号不一致">身份证号不一致</el-checkbox>
            <el-checkbox label="医院名称有误">医院名称有误</el-checkbox>
            <el-checkbox label="个人描述不合规">个人描述不合规</el-checkbox>
            <el-checkbox label="资质存在疑问">资质存在疑问</el-checkbox>
            <el-checkbox label="其他">
              其他
              <el-input
                v-show="otherShow"
                v-model="otherReason"
                placeholder="请输入其他原因"
                style="width: 200px"
                size="small"
                maxlength="10"
              ></el-input>
            </el-checkbox>
          </el-checkbox-group>
        </div>

        <div class="other-item" style="align-items: center">
          <div style="width: 100px; text-align: right; padding-right: 20px">
            审核备注
          </div>
          <el-input
            v-model="reviewed_remark"
            placeholder="请输入"
            style="width: 400px"
            size="small"
            maxlength="20"
          ></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="reasonShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="refuse" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import platform from "../../../api/platform";
import doctor from "../../../api/doctor";
import DocMsg from "../../../components/common/DocMsg.vue";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctorName: "",
      doctorPhone: "",
      province_id: "",
      proList: [],
      date: [],
      authStatus: 0,
      Selection: [],
      reviewed_id: "",
      reasonShow: false, //审核不通过原因弹窗
      refuseList: [], //拒绝原因弹窗
      auth_status: 3,
      is_pre: "",
      otherReason: "",
      reviewed_remark: "",
      major_name: "",
      is_major_name: false,
      dialog: false,
      tableData2: [],
      selection_id: "",
      doctor_name: "",
      doctor_id: "",
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    //其他拒绝理由是否可见
    otherShow() {
      if (this.refuseList.indexOf("其他") != -1) {
        return true;
      } else {
        this.otherReason = "";
        return false;
      }
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取认证记录列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctorName,
        doctor_phone: this.doctorPhone,
        auth_status: this.authStatus,
        province_id: this.province_id,
        start_time: "",
        end_time: "",
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      doctor
        .doctorAuthList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.update_time = platform.timestampToTime(item.update_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post("platform/platform/getProvinceCityDistrict")
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    //筛选状态
    changeLogList() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChangetable(val) {
      this.Selection = val;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //详情
    toDetail(reviewed_id) {
      this.$router.push({
        path: "/home/doctor/examinedetail",
        query: {
          reviewed_id,
        },
      });
    },
    //审核
    examine(row) {
      let { reviewed_id, doctor_id, doctor_name, major_name } = row;
      this.doctor_id = doctor_id;
      this.doctor_name = doctor_name;
      this.reviewed_id = reviewed_id;
      this.reviewed_remark = "";
      this.major_name = major_name;
      this.is_major_name = major_name != "";
      this.auth_status = 3;
      this.is_pre = "";
      this.reasonShow = true;
    },
    //批量审核
    examineAll() {
      if (!this.Selection.length) {
        this.$message.error("请勾选'审核中'的记录");
        return false;
      }

      let is_major_name_all = this.Selection.every((item) => {
        return item.major_name != "";
      });
      if (!is_major_name_all) {
        this.$message.error("所选医生中含有未填写专业的医生");
        return false;
      }
      let selectId = this.Selection.map((item) => {
        return item.reviewed_id;
      });
      let reviewed_id = selectId.toString();
      this.examine({ reviewed_id });
    },
    //医生提成设置弹窗
    showDialog() {
      let loading = this.$loading();
      let data = {
        doctor_id: this.doctor_id,
        page: 1,
        pageNumber: 100,
      };
      this.axios
        .post("platform/doctor/getHospitalDoctorList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData2 = res.data.list.map((item) => {
              item.edit = false;
              return item;
            });
            this.dialog = true;
            loading.close();
          }
        });
    },
    refuse() {
      if (this.refuseList.length == 0 && this.auth_status == 4) {
        this.$message.error("必须选择不通过原因！");
        return false;
      }
      if (this.major_name == "" && this.auth_status == 3) {
        this.$message.error("请输入医生所在专业！");
        return false;
      }

      if (this.is_pre === "" && this.auth_status == 3) {
        this.$message.error("请选择开方权限！");
        return false;
      }
      let reviewed_id = this.reviewed_id;
      let reason = this.refuseList.toString();
      if (reason.indexOf("其他") != -1) {
        reason = reason.replace("其他", this.otherReason);
      }

      let params = {
        reviewed_id,
        auth_status: this.auth_status,
        is_pre: this.is_pre,
        reviewed_remark: this.reviewed_remark,
        major_name: this.major_name,
      };
      if (this.auth_status == 4) {
        params.reason = reason;
      }
      doctor.auditDoctor(params).then((res) => {
        if (res.code == 0) {
          if (this.auth_status == 4) {
            this.$message.error("该医生审核未通过!");
          } else {
            this.$message.success("该医生审核通过!");
          }
        }
        this.refuseList = [];
        this.reasonShow = false;
        this.getList();
      });
    },
  },
  created() {
    if (this.$route.params.doctor_name) {
      this.doctorName = this.$route.params.doctor_name;
      this.doctorPhone = this.$route.params.phone;
    }
    this.getList();
    this.getProvince();
  },
  activated() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.other {
  .el-checkbox {
    width: 130px;
    margin-bottom: 10px;
  }
  .other-item {
    display: flex;
    margin-bottom: 10px;
    .title {
      width: 180px;
      text-align: right;
      padding-right: 20px;
    }
    .title::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
</style>
